export default "__VITE_ASSET__CFdmZIhs__"